export const container = `flex items-center gap-3 p-3 bg-ll-background font-medium tracking-wider`;
